<template>
    <div>
        <div class="chart-container" :style="{height: `${containerHeight}px`}">
            <h1>家校直通车意见统计</h1>
            <div class="access-chart" id="chart"></div>
        </div>
    </div>
</template>

<script>
    import echarts from 'echarts';
    import {getTrainTypeStatisticalList} from '@/api/accounting/accounting'

    function drawChart(containerId, config) {
        const option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow',
                    crossStyle: {
                        color: '#fff'
                    }
                },
                formatter: function (params) {
                    let str = '';
                    params.reverse().forEach(item => {
                        str += `${item.seriesName}&nbsp;:&nbsp;${item.value}<br />`
                    });
                    return str;
                }
            },

            color: ['#50E0BD', '#f08080'],
            label: {
                normal: {
                    show: true,
                    color: '#fff',
                    align: 'center',
                    textStyle: {
                        fontSize: '36px',
                        fontWeight: 'bold',
                    }
                }
            },
            dataZoom: {
                zoomLock: true,
                show: config.isNoZoom ? false : config.xAxisData.length > 4,
                realtime: true,
                start: 0,
                end: config.isNoZoom ? 100 : 100 / config.xAxisData.length * 4 > 100 ? 100 : 100 / config.xAxisData.length * 4
            },
            legend: {
                data: [ '未处理', '已处理'],
            },
            grid: {
                left: "14%",
                right: "12%",
                bottom: "18%",
                top: "20%"
            },
            xAxis: [
                {
                    type: 'category',
                    data: config.xAxisData,
                    axisLine: {},
                    axisLabel: {
                        interval: 0,
                        formatter: function (value) {
                            let str = '';
                            for (let i = 0; i < value.length; i++) {
                                str += value[i];
                                if (i % 10 === 0 && i !== 0) {
                                    str += '\n';
                                }
                            }
                            return str;
                        }
                    },
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    min: 0,
                }
            ],
            series: [{
                barCategoryGap: '50%',
                name: '已处理',
                type: 'bar',
                stack: 'one',
                data: config.batched,
            }, {
                barCategoryGap: '50%',
                name: '未处理',
                type: 'bar',
                stack: 'one',
                data: config.notBatch,
            } ]
        };

        if (document.getElementById(containerId) !== null) {
            echarts.init(document.getElementById(containerId)).setOption(option);
        } else {
            document.getElementById(containerId).setOption(option);
        }
    }

    export default {
        name: "accounting",
        data() {
            return {
                containerHeight: 0
            }
        },
        mounted() {
            this.containerHeight = window.innerHeight - 300;
            getTrainTypeStatisticalList()
                .then(res => res.data)
                .then(data => {
                    const args = {
                        xAxisData: [],
                        notBatch: [],
                        batched: [],
                        stuPercent: [],
                        teaPercent: [],
                        isNoZoom: false
                    };
                    data.data.forEach(item => {
                        if (item !== null && item.totalCount !== 0) {
                            args.xAxisData.push(item.name);
                            args.batched.push(item.totalCount - item.notBatchCount);
                            args.notBatch.push(item.notBatchCount);
                        }
                    });
                    drawChart('chart', args);
                })
        }
    }
</script>

<style lang="scss" scoped>
    .chart-container {
        overflow-y: auto;
        overflow-x: hidden;
        height: 614px;
        padding: 20px;
        h1 {
            text-align: center;
            font-size: 30px;
            color: #34373E;
        }
    }

    .table-container {
        padding-left: 8px;
        padding-right: 8px;
    }

    .access-chart {
        height: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/views/accounting/accounting.vue